module.exports = function() {
  return new Worker(__webpack_public_path__ + "4ecc6fb86b75a4a9bac1.worker.js");
};